import React, { useState } from 'react'
import AsyncCreatableSelect from 'react-select/async-creatable'
import { showSuccess, showError } from '../utils/notifications.js'
import { t } from '../../i18n.js'

// Client selection with async search and creation.
// `translations` is the new_valuation.client_select subtree from Rails.
export default function ClientSelect({ value, onChange, searchUrl, createUrl, csrfToken, translations }) {
  const [selectedOption, setSelectedOption] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [key, setKey] = useState(0) // For forcing refresh

  const loadOptions = async (inputValue) => {
    const response = await fetch(`${searchUrl}?q=${encodeURIComponent(inputValue)}`)
    const data = await response.json()
    return data.map(item => ({ value: item.id, label: item.title }))
  }

  const handleCreate = async (inputValue) => {
    setIsLoading(true)
    try {
      const response = await fetch(createUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({ create: { title: inputValue } })
      })

      const data = await response.json()
      if (data.success) {
        const newOption = { value: data.id, label: data.title }
        setSelectedOption(newOption)
        onChange(data.id, data.title)
        setKey(prev => prev + 1) // Force refresh to reload options
        showSuccess(t('created', translations, { title: data.title }))
        return newOption
      } else {
        showError(data.errors ? Object.values(data.errors).flat().join(', ') : t('failure', translations))
      }
    } catch (error) {
      showError(t('failure', translations))
      console.error('Error creating client:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="mb-3">
      <label className="form-label">{t('label', translations)}</label>
      <AsyncCreatableSelect
        key={key}
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        value={selectedOption}
        onChange={(option) => {
          setSelectedOption(option)
          onChange(option?.value || null, option?.label || null)
        }}
        onCreateOption={handleCreate}
        placeholder={t('placeholder', translations)}
        isClearable
        isDisabled={isLoading}
        isLoading={isLoading}
        formatCreateLabel={(inputValue) => t('create_label', translations, { input: inputValue })}
        className="react-select-container"
        classNamePrefix="react-select"
      />
      <div className="form-text">{t('help', translations)}</div>
    </div>
  )
}
